import {
  BAJAJ,
  BHARTI_AXA,
  FIRE_INSURANCE,
  FIRE_LOSS_OF_PROFIT,
  formType,
  HDFC_ERGO,
  ICICI_LOMBARD,
  IFFCO_TOKIO,
  LIBERTY,
  NEW_INDIA,
  ORIENTAL_INSURANCE,
  RELIANCE,
  ResourceProductType,
  ROYAL_SUNDARAM,
  SBI,
  UNITED_INDIA,
  UNIVERSAL_SOMPO,
} from './constants';

export const Fire: ResourceProductType = {
  [BAJAJ]: {
    [FIRE_INSURANCE]: [
      {
        formLink: 'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Bajaj%20Allianz/Bajaj.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [BHARTI_AXA]: {
    [FIRE_INSURANCE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Bharti%20AXA/bharti-axa-fire-insurance-claim-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [HDFC_ERGO]: {
    [FIRE_INSURANCE]: [
      {
        formLink: 'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/HDFC%20Ergo/Hdfc.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [ICICI_LOMBARD]: {
    [FIRE_LOSS_OF_PROFIT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/ICICI%20Lombard/Fire%20Loss%20of%20Profit/icici%20lombard-fire_loss_of_profit.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [IFFCO_TOKIO]: {
    [FIRE_INSURANCE]: [
      {
        formLink: 'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Iffco%20Tokio/Iffco.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [LIBERTY]: {
    [FIRE_INSURANCE]: [
      {
        formLink: 'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Libery%20Insurance/Liberty.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [NEW_INDIA]: {
    [FIRE_INSURANCE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/New%20India%20Assurance/Standard%20Perils/Fire%20Insurance%20Claim%20Form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [ORIENTAL_INSURANCE]: {
    [FIRE_INSURANCE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Oriental%20Insurrance/Oriental%20-%20Claim%20Form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [RELIANCE]: {
    [FIRE_INSURANCE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Reliance%20General%20Insurance/Reliance%20General%20Insurance.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [ROYAL_SUNDARAM]: {
    [FIRE_INSURANCE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Royal%20Sundaram/Standard%20Peril/Royal%20Sundram%20-%20Claim%20Form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [SBI]: {
    [FIRE_LOSS_OF_PROFIT]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/SBI%20General/Fire%20Loss%20of%20Profit/sbi-insurance-fire-loss-of-profit-insurance-proposal-form.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [UNITED_INDIA]: {
    [FIRE_INSURANCE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/United%20India/Standard%20Perils/United.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
  [UNIVERSAL_SOMPO]: {
    [FIRE_INSURANCE]: [
      {
        formLink:
          'https://github.com/PrishaPolicy/insurance-resources/raw/main/Fire/Universal%20Sompo/Standard%20Perils/Universal%20sompo.pdf',
        formType: formType.ClaimForm,
      },
    ],
  },
};
